import { IUser, User } from '../user';
import { MENTION_REGEX } from './mention.constant';
import { IMentionComment, IMentionCommentData } from './mention.types';

export abstract class MentionCommentMixin implements IMentionComment {
  readonly mentions: IUser[] = [];
  abstract text: string;

  constructor(data?: IMentionCommentData) {
    if (data) {
      if (data.mentions) {
        this.mentions = data.mentions.map(mention => new User(mention));
      }
    }
  }

  private getMentionByUserId(id: number) {
    return this.mentions.find(mention => mention.id == id);
  }

  getTextHtml(): string {
    // Replace matches with corresponding strings
    const replacedText = this.text.replace(
      MENTION_REGEX,
      (matchedText, userId) => {
        const mention = this.getMentionByUserId(userId);
        let replacementText = matchedText;
        // if user is found the replace matching regex with user fullname
        if (mention) {
          const span = document.createElement('span');
          span.textContent = `@${mention.toString()}`;
          span.setAttribute('class', 'mention');
          span.setAttribute('id', 'mention-user');
          span.dataset['mention'] = String(mention.id);

          replacementText = span.outerHTML;
        }
        return replacementText;
      }
    );

    return replacedText;
  }

  // readonly text
  static parseHtmlToMentionText(html: string): string {
    // Create a DOMParser to parse the HTML text
    const doc = new DOMParser().parseFromString(html, 'text/html');

    // Get all the elements with class "mention"
    const mentionSpans = doc.querySelectorAll('.mention');

    mentionSpans.forEach(function(spanElement) {
      // Get the userId from the data-mention attribute
      const userId = spanElement.getAttribute('data-mention');

      // Create a new text node with the desired format
      const newText = doc.createTextNode('@uid:' + userId);

      // Replace the <span> with the new text node
      spanElement.parentNode?.replaceChild(newText, spanElement);
    });

    const body = doc.querySelector('body');

    return body?.innerHTML ?? html;
  }
}
